import { marked } from 'marked';

interface MarkdownPreviewProps {
  markdown: string;
  className?: string;
}

export function MarkdownPreview({ markdown, className = '' }: MarkdownPreviewProps) {
  // Configure marked for inline formatting only
  marked.setOptions({
    breaks: true,
    gfm: true,
  });

  const html = marked.parse(markdown || '');

  return (
    <div 
      className={`markdown-preview leading-relaxed ${className}`}
      style={{ color: 'var(--text-primary)' }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
